import { useDispatch } from "react-redux";
import { useDrop } from "react-dnd";
import { IMosaicTabNode } from "src/utils/MosaicTree";
import { moveTabNode, moveTabNodeToEnd } from "src/redux/actions/Mosaic.Actions";

interface IMosaicBarDropTargetProps {
  path: string[];
}

const MosaicTabBarDropTarget = (props: IMosaicBarDropTargetProps): JSX.Element => {
  const dispatch = useDispatch();
  const [{ isOver }, drop] = useDrop({
    accept: "DND_NODE",
    drop(item: any, monitor: any) {
      const dragTabNode: IMosaicTabNode = monitor.getItem().mosaicTabNode;

      if (item.path !== props.path) {
        dispatch(moveTabNode(item.path, props.path, dragTabNode, null));
      } else {
        dispatch(moveTabNodeToEnd(props.path, dragTabNode));
      }
    },
    collect(monitor: any) {
      return {
        isOver: monitor.isOver(),
      };
    },
  });

  return (
    <div ref={drop} style={{ flexGrow: 1 }}>
      {isOver && (
        <div
          style={{
            width: "100%",
            height: "100%",
            background: "rgba(0, 126, 185, 0.95",
          }}
        />
      )}
    </div>
  );
};

export default MosaicTabBarDropTarget;
